import { Button as AntdButton } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  min-height: 408px;
`;

export const AgreementWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  gap: 8px;
`;

export const AgreementLabel = styled.p`
  & span {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }
  margin: 0;
`;

export const TnCFrameWrapper = styled.div`
  border: 1px solid #ededed;
  border-radius: 4px;
`;

export const TnCFrame = styled.iframe`
  border: none;
  border-radius: 4px;
  width: 100%;
  height: 408px;
`;

export const AgreementTextWrapper = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;

  & span {
    color: #00ab6b;
    font-weight: 700;
    cursor: pointer;
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0 0;
`;

interface IButtonProps {
  disabled?: boolean;
}

export const NextButton = styled(AntdButton)<IButtonProps>`
  width: 100%;
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;

  &:disabled {
    background-color: #cceee1 !important;
    color: #ffffff !important;
  }
`;
